import { FC } from 'react';
import { Box, Heading, Stack } from '@chakra-ui/react';

import Text from 'components/_core/Text';

import GuaranteesList from '../GuaranteesList';

interface PhoneSectionProps {
  description: string;
  title: string;
  phoneNumber: string;
  isCovered: boolean;
}

const PhoneSection: FC<PhoneSectionProps> = (props) => {
  const { description, isCovered, phoneNumber, title } = props;
  return (
    <Stack spacing="space-16">
      <Heading>{title}</Heading>
      {isCovered ? (
        <>
          <Text key={description}>{description}</Text>

          <Box
            as="a"
            background="grey.200"
            borderRadius="8px"
            href={`tel:${phoneNumber}`}
            maxWidth="320px"
            paddingY="space-16"
            textAlign="center"
          >
            <Heading size="lg" variant="number">
              {phoneNumber}
            </Heading>
          </Box>
        </>
      ) : (
        <>
          <GuaranteesList
            guarantees={{ items: [description], title: title }}
            isInclude={false}
          />
        </>
      )}
    </Stack>
  );
};

export default PhoneSection;
